import { render, staticRenderFns } from "./DiviceDeadList.vue?vue&type=template&id=b83d7d6c&scoped=true&"
import script from "./DiviceDeadList.vue?vue&type=script&lang=js&"
export * from "./DiviceDeadList.vue?vue&type=script&lang=js&"
import style0 from "./DiviceDeadList.vue?vue&type=style&index=0&id=b83d7d6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83d7d6c",
  null
  
)

export default component.exports